// extracted by mini-css-extract-plugin
module.exports = {"row":"join_row__2-a4J","col":"join_col__3GnmH","ueberschrift":"join_ueberschrift__L235D","col1":"join_col1__7gqjR","pad15":"join_pad15__1Ei0_","img":"join_img__3tZMM"};